import { render, staticRenderFns } from "./InvalidCoupons.vue?vue&type=template&id=ca906b78&scoped=true"
import script from "./InvalidCoupons.vue?vue&type=script&lang=js"
export * from "./InvalidCoupons.vue?vue&type=script&lang=js"
import style0 from "./InvalidCoupons.vue?vue&type=style&index=0&id=ca906b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca906b78",
  null
  
)

export default component.exports